/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$marker (jQuery element)
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function add_marker($marker, map) {

    var lat = $marker.attr('data-lat');
    var lng = $marker.attr('data-lng');

    var latlng = new google.maps.LatLng(lat, lng);

    var url_image = $marker.attr('data-icon');
    
    var icon = {
        url: $marker.attr('data-icon'),
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0)
    };

    // create marker

    // marker normal
    var marker = new RichMarker({
        position: latlng,
        map: map,
        icon: icon,
        content: '<div class="custom-marker"><img class="marker-img" src="' + url_image + '"/></div>',
        shadow: 'none'
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function () {

            infowindow.open(map, marker);

        });
    }

}

/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);

    });

    // only 1 marker?
    if (map.markers.length === 0) {
        $("#bp-status-map").append("<br><b>Il n’y a aucun résultat sur la carte.</b>");
        // set center of map
        map.setCenter(new google.maps.LatLng(47.213422, -1.5484143567993764));
        map.setZoom(8);
    } else if (map.markers.length === 1) {

        $("#bp-status-map").append('<br><b>Il y a ' + map.markers.length + ' résultat sur la carte.</b>');

        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(16);

    } else {

        $("#bp-status-map").append('<br><b>Il y a ' + map.markers.length + ' résultats sur la carte.</b>');

        // fit to bounds
        map.fitBounds(bounds);

    }
}


/*
 *  new_map
 *
 *  This function will render a Google Map onto the selected jQuery element
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$el (jQuery element)
 *  @return	n/a
 */

function new_map($el) {

    // var
    var $markers = $el.find('.marker');

    // vars
    var args = {
        zoom: 32,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        styles: [
            {
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "gamma": 0.54
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    {
                        "color": "#005874"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fff"
                                //"color": "#ec6a66"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "gamma": 0.48
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "gamma": 7.18
                    }
                ]
            }
        ]
    };


    // create map
    var map = new google.maps.Map($el[0], args);

    // add a markers reference.
    map.markers = [];

    // add markers
    $markers.each(function () {

        add_marker($(this), map);

    });

    // center map
    center_map(map);

    // return
    return map;

}

/*
 *
 *
 *  This function will render each map when the document is ready (page has loaded)
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	5.0.0
 *
 *  @param	n/a
 *  @return	n/a
 */

// global var
var map = null;

// initialisation carte : fonction appelée avec le paramètre callback google apî &callback=initMap
function initMap() {

    $('.acf-map').each(function () {

        // create map
        map = new_map($(this));

    });



}


// initMap in main.js now

/*
window.onload = function (e) {
    if (typeof google === 'object' && typeof google.maps === 'object') {
        console.log('1 window.onload');
        initMap();
    }
};
*/

